
import { VueCookieNext } from "vue-cookie-next";

// 获取当前语言
export function $lang() {
  const lang = VueCookieNext.getCookie( 'lang' );
  return lang;
}
// lang转换
export function $rdoLang( lang = $lang()) {
  if ( !lang || /^zh[-,,,_]{0,1}|^cn$/.test( lang )) {
    return 'cn';
  }
  if ( /^en[-,,,_]{0,1}/.test( lang )) {
    return 'en';
  }
  if ( /^ja[-,,,_]{0,1}/.test( lang )) {
    return 'ja';
  }
  return lang;
}